"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwButton = _interopRequireDefault(require("../cwbutton/CwButton"));

var _CwFlyout = _interopRequireDefault(require("../cwflyout/CwFlyout"));

var _CwFlyoutButton = _interopRequireDefault(require("./CwFlyoutButton.scss"));

var CwFlyoutButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwFlyoutButton, _React$Component);

  function CwFlyoutButton() {
    var _this;

    (0, _classCallCheck2.default)(this, CwFlyoutButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwFlyoutButton).call(this));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentWillMount", function () {
      window.addEventListener('mousedown', _this.handleOnBlur, false);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnClick", function () {
      _this.getButtonCenter();

      _this.setState(function (prevState) {
        return {
          flyout: !prevState.flyout
        };
      });

      if (_this.props.onClick) {
        _this.props.onClick();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnBlur", function () {
      if (_this._ignoreBlur) {
        return;
      }

      if (_this.state.flyout) {
        _this.setState({
          flyout: false
        });

        if (_this.props.onBlur) {
          _this.props.onBlur();
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mouseDownHandler", function () {
      _this._ignoreBlur = true;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mouseUpHandler", function () {
      _this._ignoreBlur = false;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getButtonCenter", function () {
      var node = _this.button.cwButton;
      var rect = node.getBoundingClientRect();
      _this._buttonX = rect.left + (rect.right - rect.left) / 2;
      _this._buttonY = rect.top + (rect.bottom - rect.top) / 2;

      _this.setState({
        buttonX: node.offsetWidth / 2,
        buttonY: node.offsetHeight
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "disabled", function () {
      return _this.props.children === null || _this.props.children.length < 1;
    });
    _this._ignoreBlur = false;
    _this.state = {
      flyout: false,
      buttonY: 0,
      buttonX: 0
    };
    _this._buttonX = 0;
    _this._buttonY = 0;
    return _this;
  }

  (0, _createClass2.default)(CwFlyoutButton, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousedown', this.handleOnBlur);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        onMouseDown: this.mouseDownHandler,
        onMouseUp: this.mouseUpHandler,
        className: _CwFlyoutButton.default.wrap
      }, _react.default.createElement(_CwButton.default, {
        disabled: this.props.disabled || this.disabled(),
        ref: function ref(input) {
          return _this2.button = input;
        },
        icon: this.props.icon,
        onBlur: this.handleOnBlur,
        onFocus: this.props.onFocus,
        onClick: this.handleOnClick,
        value: this.props.value,
        rightIcon: this.props.rightIcon,
        height: this.props.buttonHeight,
        isStandard: this.props.buttonIsStandard,
        style: this.props.buttonStyle,
        isMenu: true
      }), this.state.flyout ? _react.default.createElement(_CwFlyout.default, {
        ref: function ref(input) {
          return _this2.dialog = input;
        },
        id: 0,
        header: this.props.header ? this.props.header : this.props.value,
        x: this.state.buttonX,
        y: this.state.buttonY,
        xCoord: this._buttonX,
        yCoord: this._buttonY
      }, this.props.children) : null);
    }
  }]);
  return CwFlyoutButton;
}(_react.default.Component);

CwFlyoutButton.propTypes = {
  /**
   * Callback function that is fired when CwFlyoutButton is focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired when CwFlyoutButton is blurred
   */
  onBlur: _propTypes.default.func,

  /**
   * Used to disable the button
   */
  disabled: _propTypes.default.bool,

  /**
   * Text to be shown in the button
   */
  value: _propTypes.default.string,

  /**
   * Content to be shown in the flyout
   */
  children: _propTypes.default.any,

  /**
   * Optional icon placed on left side of button
   */
  icon: _propTypes.default.string,

  /**
   * Path to a svg icon to be displayed on the right side of the button text
   */
  rightIcon: _propTypes.default.string,

  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes.default.string,

  /**
   * Used to control button height
   */
  buttonHeight: _propTypes.default.number,

  /**
   * Used to control if the button is standard or light
   */
  buttonIsStandard: _propTypes.default.bool,

  /**
   * Override the styles of the root element
   */
  buttonStyle: _propTypes.default.object,

  /**
   * Used to control order when tabbing through items
   */
  tabIndex: _propTypes.default.number,

  /**
   * Optional header for the flyout if on specified the header defaults to the value prop
   */
  header: _propTypes.default.string,

  /**
   * Callback function fired when button is clicked
   */
  onClick: _propTypes.default.func
};
var _default = CwFlyoutButton;
exports.default = _default;